









































































































































































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import { TbMember } from '@/http';
import dayjs from "dayjs";
import calculate from '@/common/util/calculate';
import { Toast } from 'vant';
import Bus from '@/common/util/bus';
@Component({
    components: {
    },
})
export default class selectCoupon extends Vue {
    public $refs: {
    };

    @Prop({
        default:false
    })
    show:Boolean;

    list=[];
    active = 0;

    fmoney = fmoney;

    /**优惠券列表 */
    @Prop({
        type:Object,
        default:()=>{
            return {
                availableList:[],
                notAvailableList:[],
                gwList:[],
            }
        }
    })
    couponList:any;

    /**已选中优惠券优惠金额 */
    @Prop({
        default:0
    })
    yhAmount:number;
    /**应收总额 */
    @Prop({
        default:0
    })
    receivablesNew:number;
    receivables=0
    /**已选中优惠券id */
    @Prop({
        default:""
    })
    activeId:String;

    /**优惠券选中项 */
    form:any={};
    form2:any={id:""};

    /**去除无码商品和赠品的应收总额 */
    @Prop({
        default:0
    })
    canUseDiscountPrice:Number;

    /**是否达到使用门槛 */
    canUse=true;

    /**优惠总额 */
    get discountAmount(){
        let val = 0;
        val = calculate.subtraction(this.receivables,this.totalAfterDiscount);
        return val;
    }

    /**优惠后总额 */
    totalAfterDiscount = 0;
   

    created() {
        if(this.couponList.availableList.length>0){
            if(this.activeId){
                this.form = this.couponList.availableList.filter(v=>v.id==this.activeId)[0];
                this.receivables = calculate.addition(this.receivablesNew,this.yhAmount);
                this.chargeMK(this.form.coupon);
            }else{
                this.form = this.couponList.availableList[0]
                this.receivables = this.receivablesNew;
                this.chargeMK(this.form.coupon);
            }
        }
    }   
    
    mounted() {
        Bus.$on('resCalcCoupon',(res)=>{
            let arr = res.items.map(v=>v.finalPrice);
            if(arr.length>0){
                this.totalAfterDiscount = arr.reduce((a,b)=>calculate.addition(a,b));
            }
        })
    }

    closeFun(){
        this.$emit("closeFun");
    }
    chooseTab(val){
        this.active = val;
        if(val==0&&this.couponList.availableList.length>0){
            this.form = this.couponList.availableList[0]
        }
        if(val==1&&this.couponList.notAvailableList.length>0){
            this.form2 = this.couponList.notAvailableList[0]
        }
    }
    getThreshold(item){
      let str = "";
      switch (item.threshold) {
        case 0:
          str="无使用门槛"
          break;
        case 1:
          let money = fmoney(item.satisfiedQuantity)
          str="满"+money+'元可用';
          break;
        case 2:
          str="满"+item.satisfiedQuantity+'件可用';
          break;
       
      
        default:
          break;
      }
      return str;
    }
    getTimeType(item,item2,type='list'){
      let str,txt,connectUnit = "";
      if(type=='list'){
        txt='有效日期：';
        connectUnit = '-'
      }else{
        txt='有效期：';
        connectUnit = '至'
      }
      if(item.timeType==0){
        str=txt+"无使用期限"
      }else{
        let startTime = dayjs(item2.startTime).format("YYYY.MM.DD");
        let endTime = dayjs(item2.endTime).format("YYYY.MM.DD");
        str=txt+startTime+connectUnit+endTime;
      }
     
      return str;
    }

    getMk(item){
      let str = "";
      let extip=item.amount?`，最多优惠${fmoney(item.amount)}元`:''
      let extip2=item.amount?`，最多优惠${fmoney(item.amount)}元`:''
      if(item.method==0){
        switch (item.threshold) {
          case 0:
            str="使用门槛：无使用门槛"+extip;
            break;
          case 1:
            let satisfiedQuantity = fmoney(item.satisfiedQuantity)
            let amount = fmoney(item.amount)
            str=`使用门槛：订单满${satisfiedQuantity}元，减免${amount}元`;
            break;
          default:
            break;
        }
      }else if(item.method==1){
        switch (item.threshold) {
          case 0:
            str=`使用门槛：无使用门槛，享${item.discount}折`+extip;
            break;
          case 1:
            str=`使用门槛：订单满${fmoney(item.satisfiedQuantity)}元，享${item.discount}折`+extip2;
            break;
          default:
            break;
        }
      }
      return str;
    }
    getUseStore(item){
      let str ='';
      let num = item.details.filter(v=>v.dataType==1).length;
      let storeList = item.details.filter(v=>v.dataType==1).map(j=>j.dataName).join(';');
      str = `共${num}家：${storeList}`
      return str;
    }
    getProduct(item){
      let str = "";
      switch (item.goodsLimit) {
        case 0:
          str="全部商品适用"
          break;
        case 1:
          let num = item.details.filter(v=>v.dataType==2).length;
          str=`适用${num}款商品`
          break;
      
        default:
          break;
      }
      return str;
    }
    getUnuseProduct(item){
      let str ='';
      str = item.details.filter(v=>v.dataType==2).length
      return str;
    }
    chooseCoupon(item){
        this.form = item;
        this.chargeMK(item.coupon);
    }
    chooseCoupon2(item){
        this.form2 = item;
    }
    /**判断使用门槛 */
    chargeMK(item){
        this.canUse = item.threshold==1&&this.canUseDiscountPrice<item.satisfiedQuantity?false:true;
        if(!this.canUse){
            Toast("未达到使用门槛");
            return;
        }
        this.$emit("calcCoupon",this.form)
    }
    confirmFun(){
        if(!this.canUse) return;
        if(this.active==1) return;
        if(!this.form.id) return;
        let obj = Object.assign({},this.form,{
            yhAmount:this.discountAmount,
        })
        this.$emit("confirmCoupon",obj);
        this.closeFun();
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/selectCoupon.vue